<template>
    <div class="ecaterix-container">
        <Navigation v-if="!isUnderOrEqualViewport1024" />
        <Header />
        <Nuxt />
        <Footer />
        <MobileMenu />
        <MenuBar v-if="globalSettings?.mainUiInterface?.mobileBarUiType !== 'mobileBar_hide'" />
        <EcomMyModal />
        <template v-if="noScriptCode">
            <noscript v-html="noScriptCode"></noscript>
        </template>
    </div>
</template>

<script>
import Header from '~/themes/ecaterix/components/widgets/Header';

import themeStylesVars from '~/themes/ecaterix/assets/styles/vars';
import { convertJSONStylesToGlobalVarsContent } from '~/utils/convertors';
import viewport from '~/mixins/viewport';
import { mapGetters } from 'vuex';
import dynamicFont from '~/mixins/dynamicFont';

export default {
    mixins: [viewport, dynamicFont],
    components: {
        Header,

        Footer: () => import('~/themes/ecaterix/components/widgets/Footer'),
        Navigation: () => import('~/themes/ecaterix/components/widgets/Navigation'),
        MobileMenu: () => import('~/themes/ecaterix/components/widgets/MobileMenu'),
        MenuBar: () => import('~/themes/ecaterix/components/widgets/MenuBar'),
        EcomMyModal: () => import('@/components/modals/EcomMyModal.vue')
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getIcons: 'global/getIcons',
            noScriptCode: 'global/getNoScriptCode'
        }),
        projectName() {
            return this.globalSettings.project;
        },
        logo() {
            return this.globalSettings?.logo?.logoDark || null;
        },
        getFavicon() {
            return this.getIcons?.favicon || this.logo;
        },
        colors() {
            return this.globalSettings.colors.dark_theme || null;
        }
    },
    watch: {
        '$i18n.locale': async function (newVal, oldVal) {
            // Not reliable solution
            this.$fetch();
            await this.$store.dispatch('footer/fetchFooterSettings');
            await this.$store.dispatch('global/fetchGlobalSettings');

            // const modals = await this.$axios.$get('/base/pop-up-configuration');
            //
            // await this.$store.dispatch('modals/setModals', modals);
        }
    },
    async fetch() {
        await this.$store.dispatch('categories/fetchCategories');
        // const modals = await this.$axios.$get('/base/pop-up-configuration');
        //
        // this.$store.dispatch('modals/setModals', modals);
    },
    head() {
        const scripts = [];
        const styles = [
            {
                hid: 'theme-css-variables',
                innerHTML: convertJSONStylesToGlobalVarsContent(themeStylesVars, this.colors),
                type: 'text/css'
            }
        ];
        const metas = [];

        const css = this.$store.state.global.globalSettings?.styles?.css;
        const js = this.$store.state.global.globalSettings?.styles?.script;

        const facebookVerification = this.$store.state.global.globalSettings?.sitesettingsstatistic?.facebook_verification;
        const googleAnalytics4 = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_analytics_4;
        const googleSearchConsole = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_search_console;
        const googleTagManager = this.$store.state.global.globalSettings?.sitesettingsstatistic?.google_tag_manager;
        const yandexMetrika = this.$store.state.global.globalSettings?.sitesettingsstatistic?.yandex_metrika;

        if (facebookVerification) {
            metas.push({
                hid: 'facebook-domain-verification',
                name: 'facebook-domain-verification',
                content: facebookVerification
            });
        }

        if (googleSearchConsole) {
            metas.push({
                hid: 'google-site-verification',
                name: 'google-site-verification',
                content: googleSearchConsole
            });
        }

        // if (process.client) {
        if (googleAnalytics4) {
            scripts.push({
                hid: 'google-analytics-gtag',
                src: `https://www.googletagmanager.com/gtag/js?id=${googleAnalytics4}`,
                async: true
            });
            scripts.push({
                hid: 'google-analytics-config',
                innerHTML: `
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${googleAnalytics4}');
                    `
            });
        }

        if (googleTagManager) {
            scripts.push({
                hid: 'google-tag-manager',
                innerHTML: `
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
                        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','${googleTagManager}');
                    `
            });
        }

        if (yandexMetrika) {
            scripts.push({
                hid: 'yandex-metrika',
                innerHTML: `
                        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0];k.async=1;k.src=r;a.parentNode.insertBefore(k,a)})
                        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                        ym(${yandexMetrika}, "init", {
                            clickmap:true,
                            trackLinks:true,
                            accurateTrackBounce:true
                        });
                    `
            });
        }
        // }

        if (js) {
            scripts.push({
                hid: 'custom-js',
                innerHTML: js,
                type: 'text/javascript'
            });
        }

        if (css) {
            styles.push({
                hid: 'custom-css',
                innerHTML: css,
                type: 'text/css'
            });
        }
        return {
            __dangerouslyDisableSanitizersByTagID: {
                'custom-js': ['innerHTML'],
                'google-analytics-config': ['innerHTML'],
                'google-tag-manager': ['innerHTML'],
                'yandex-metrika': ['innerHTML']
            },
            bodyAttrs: {
                style: `font-family: ${this.foundFontFile || 'Cera Pro'}, sans-serif;`
            },
            title: this.projectName,
            link: [
                {
                    rel: 'shortcut icon',
                    href: this.getFavicon
                }
            ],
            style: styles,
            script: scripts,
            meta: metas,
            htmlAttrs: {
                lang: this.$i18n.locale || 'en'
            }
        };
    },
    cache: true
};
</script>
<style lang="scss" scoped>
.ecaterix-container {
    background-color: var(--main-bg-color);
}
</style>
